import axios from 'axios';
import { API_BASE_URL } from '../apiBase';

// Memory only, scoped to the signed-in account. Mongo remains the source of truth.
const requests = new Map();
const results = new Map();
const fresh = (value) => Number(value?.contact_avatar_cache?.next_refresh_at || 0) * 1000 > Date.now();

export function cachedAvatarUrl(value) {
  // Only the authenticated, read-only local cache route. Never load a CDN URL.
  if (typeof value !== 'string') return '';
  const conversationAvatar = /^\/api\/conversations\/[a-zA-Z0-9_-]+\/avatar\?v=[a-f0-9]{64}$/.test(value);
  const contactAvatar = /^\/api\/contacts\/[a-zA-Z0-9_-]+\/avatar\?exp=\d+&sig=[a-f0-9]{64}$/.test(value);
  if (!conversationAvatar && !contactAvatar) return '';
  return `${API_BASE_URL}${value}`;
}

export function newerAvatar(current, incoming) {
  const oldCache = current?.contact_avatar_cache;
  const nextCache = incoming?.contact_avatar_cache;
  if (Number(oldCache?.checked_at || 0) > Number(nextCache?.checked_at || 0)
      || (Number(oldCache?.checked_at || 0) === Number(nextCache?.checked_at || 0)
          && Number(oldCache?.next_refresh_at || 0) > Number(nextCache?.next_refresh_at || 0))) {
    return { ...incoming, contact_profile_picture: current.contact_profile_picture, contact_avatar_cache: oldCache };
  }
  return incoming;
}

export function refreshOpenedAvatar(actorId, conversation, { force = false } = {}) {
  if (!actorId || !conversation?.id || !conversation?.contact_id || !conversation?.connection_id || conversation.is_group) return Promise.resolve(null);
  const key = JSON.stringify([API_BASE_URL, actorId, conversation.connection_id, conversation.contact_id, conversation.id]);
  const saved = results.get(key);
  if (!force && saved && fresh(saved)) return Promise.resolve(newerAvatar(conversation, saved));
  if (!force && fresh(conversation)) return Promise.resolve(null);
  if (requests.has(key)) return requests.get(key);
  const request = axios.post(`${API_BASE_URL}/api/conversations/${encodeURIComponent(conversation.id)}/avatar/refresh`, {},
    { withCredentials: true, timeout: 25000 })
    .then(({ data }) => data?.contact_avatar_cache ? data : null)
    .catch(() => ({ contact_profile_picture: conversation.contact_profile_picture || null,
      contact_avatar_cache: { status: 'error', next_refresh_at: Date.now() / 1000 + 300 } }))
    .then((data) => {
      if (data) {
        results.delete(key);
        results.set(key, data);
        while (results.size > 200) results.delete(results.keys().next().value);
      }
      return data;
    }).finally(() => requests.delete(key));
  requests.set(key, request);
  return request;
}
